import { EEthereumNetworkId } from '@ankr.com/provider';

import bnbChainIcon from 'assets/bnb.svg';
import bnbRoundedChainIcon from 'assets/bnb-rounded.svg';
import polygonChainIcon from 'assets/polygon.svg';
import polygonRoundedChainIcon from 'assets/polygon-rounded.svg';

export interface GetChainIconResult {
  default: string | null;
  rounded: string | null;
}

export function getChainIcon(chainId: number): GetChainIconResult {
  switch (chainId) {
    case EEthereumNetworkId.smartchain:
    case EEthereumNetworkId.smartchainTestnet:
      return {
        default: bnbChainIcon,
        rounded: bnbRoundedChainIcon,
      };
    case EEthereumNetworkId.polygon:
    case EEthereumNetworkId.mumbai:
      return {
        default: polygonChainIcon,
        rounded: polygonRoundedChainIcon,
      };
    default:
      return {
        default: null,
        rounded: null,
      };
  }
}
